import {
  useDeleteFlowSession,
  useSetFlowSessionName,
} from "@/api/flow_sessions";
import * as analytics from "@/utils/analytics";
import { FlowSession, InboxItem } from "@cohesive/api-client";
import toast from "react-hot-toast";

interface UseFlowSessionActionsProps {
  onDelete?: () => void;
  onRename?: () => void;
}

export function useFlowSessionActions({
  onDelete,
  onRename,
}: UseFlowSessionActionsProps = {}) {
  const setFlowSessionName = useSetFlowSessionName();
  const { mutate: deleteFlowSession } = useDeleteFlowSession();

  const handleRename = (
    flowSession: FlowSession | InboxItem["flow_session"],
    newName: string,
  ) => {
    setFlowSessionName.mutate(
      { flowSessionId: flowSession?.id!, name: newName },
      {
        onSuccess: () => {
          toast.success(`The chat has been renamed to "${newName}".`);
          analytics.trackChatRenamed();
          onRename?.();
        },
        onError: (error) => {
          toast.error(
            "Failed to rename the chat. Please try again.\n" + error.message,
          );
        },
      },
    );
  };

  const handleDelete = async (flowSession: FlowSession) => {
    try {
      await deleteFlowSession(flowSession.id);
      toast.success("The chat has been successfully deleted.");
      analytics.trackChatDeleted();
      onDelete?.();
    } catch (error) {
      toast.error("Failed to delete the chat. Please try again.\n" + error);
    }
  };

  return { handleRename, handleDelete };
}
